module.exports = __webpack_public_path__ + "img/table-rows.87ccd8b0.svg";